import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SpriteIcon } from '@/components/SpriteIcon';
import { AuthCard } from './AuthCard';

/**
 * Replaces `Pages/Auth/Lockout.cshtml`.
 *
 * Reached when the login endpoint answers `isLockedOut`. Static, and it has to
 * be: Identity's lockout window is not exposed to the client, and nothing here
 * can shorten it — an administrator has to unlock the account.
 */
export function LockoutPage() {
  const { t } = useTranslation();

  return (
    <AuthCard centered showLogo={false}>
      <div className="mb-4">
        <SpriteIcon name="lock" size={80} className="text-warning" />
      </div>

      <h2 className="h4 fw-bold mb-3">{t('auth:Auth.AccountLocked', 'Account Temporarily Locked')}</h2>

      <p className="text-muted mb-4">
        {t(
          'auth:Auth.LockoutMessage',
          'Too many failed sign-in attempts were made on this account. For your security, it has been locked.',
        )}
      </p>

      <div className="alert alert-warning d-flex align-items-center justify-content-center gap-2">
        <SpriteIcon name="shield" className="sa-icon flex-shrink-0" />
        <span>
          {t('auth:Auth.LockoutContactAdmin', 'Please contact your administrator to unlock your account.')}
        </span>
      </div>

      <div className="d-grid gap-2">
        <Link
          to="/auth-login"
          className="btn btn-primary btn-lg d-inline-flex align-items-center justify-content-center"
        >
          <SpriteIcon name="log-in" className="sa-icon me-2" />
          {t('auth:Auth.BackToLogin', 'Back to Login')}
        </Link>
      </div>
    </AuthCard>
  );
}
